<template>
  <div class="report">
    <div class="report-header">
      <div>
        <h1>DASH</h1>
        <h4>Suspicious traffic seen coming from your network</h4>
      </div>
      <div>
        <img
          class="report-logo"
          src="../../../assets/apnic.svg"
          alt="report_logo"
        />
      </div>
    </div>
    <div class="report-content">
      <div class="content-title">
        <div>
          <strong>Origin AS:</strong>
          AS{{ selectedASN.id }}
        </div>
        <div>
          <strong>Date:</strong>
          {{ date }}
        </div>
      </div>
      <CardWrapper>
        <StatsList></StatsList>
      </CardWrapper>
      <div class="content-charts">
        <CardWrapper>
          <ComparisonCard comparedWith="economy"></ComparisonCard>
        </CardWrapper>
        <span class="gap"></span>
        <CardWrapper>
          <ComparisonCard comparedWith="region"></ComparisonCard>
        </CardWrapper>
      </div>
      <CardWrapper>
        <Prefixes />
      </CardWrapper>
    </div>
    <div class="report-footer">
      <div class="data-source">
        <strong>Data source:</strong>
        DASH collects data from more than 60 honeynet sensors spread across more
        than 15 economies in the Asia Pacific.
      </div>
      <div class="methodology">
        <strong>Disclaimer:</strong>
        The data presented in DASH is collected from the APNIC Community
        Honeynet Project, which is sourced from both APNIC-operated and
        independently operated honeypots. The availability, completeness and
        accuracy of information displayed in DASH cannot be guaranteed by APNIC
        and should be used for informational purposes only. The data presented
        in DASH is not a complete or exhaustive measurement of malicious traffic
        on a network. By the nature of the honeynet’s operation, the data
        presented in DASH is limited to the traffic seen at honeypots, and is
        further limited to the traffic types the honeypots are configured to
        detect. The location data in these reports should not be considered an
        authoritative indication of the location in which a resource is
        currently in use. Location data on this site refers to the economy in
        which an organization is registered at the time they receive an Internet
        resource allocation or assignment.
      </div>
    </div>
  </div>
</template>

<script>
import StatsList from '../stats/StatsList';
import ComparisonCard from './ComparisonCard';
import Prefixes from './Prefixes';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { mapGetters, mapActions } from 'vuex';
import CardWrapper from '../../ui/CardWrapper';

dayjs.extend(utc);

export default {
  components: {
    StatsList,
    ComparisonCard,
    CardWrapper,
    Prefixes
  },
  computed: {
    ...mapGetters('dataStore', ['selectedASN', 'month']),
    date() {
      let start, end;

      if (process.env.VUE_APP_REPORT_MODE) {
        end = dayjs.utc().subtract(1, 'day');
        if (this.month === 'this') {
          start = dayjs.utc().subtract(30, 'day');
        } else if (this.month === 'last') {
          start = dayjs.utc().subtract(60, 'day');
        } else {
          return 'N/A';
        }
      } else {
        end = dayjs.utc();
        if (this.month === 'this') {
          start = dayjs.utc().subtract(29, 'day');
        } else if (this.month === 'last') {
          start = dayjs.utc().subtract(59, 'day');
        } else {
          return 'N/A';
        }
      }

      return `${start.format('DD MMM YYYY')} / ${end.format('DD MMM YYYY')}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.report {
  width: 1190px;
  height: 1684px;
  position: relative;
  padding: 20px;
  background-color: #f5f5f7;
}
.report-header {
  border-bottom: 2px solid black;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;

  h1 {
    margin: 0;
    font-weight: bold;
  }

  h4 {
    margin: 10px 0;
    font-weight: bold;
  }
}

.report-footer {
  width: calc(100% - 40px);
  border-top: 2px solid black;
  position: absolute;
  bottom: 0;
  padding: 20px;
}
.report-content {
  ::v-deep .stats-data {
    flex-direction: row !important;

    &__item {
      @include media-breakpoint-down(md) {
        padding: 0.75rem 1rem;
        border-right: 2px solid $apnic-blue;
        border-bottom: 0;

        &:first-child {
          padding-left: 0;
        }
        &:last-child {
          border: none;
          padding-right: 0;
        }
      }
    }
  }
  .content-title {
    display: flex;
    justify-content: space-between;
    font-size: 18px;
    padding-top: 16px;
    padding-bottom: 8px;
  }
  .content-charts {
    display: flex;

    & > div {
      flex: 1;
    }

    & ::v-deep {
      & .card-title {
        text-align: left;
        padding: 0 20px;
      }
      & .apexcharts-toolbar {
        display: none;
      }
    }

    .gap {
      min-width: 10px;
    }
  }
}
</style>
